import { css } from '@emotion/react';
import styled from '@emotion/styled';
import React from 'react';

import { Flex, Icon } from '~/components/blocks';
import { AppointmentsYakumaruPrescriptionIdentificationResultStatus } from '~/graphql/generated/graphql';

type Props = {
  children: React.ReactNode;
  status: AppointmentsYakumaruPrescriptionIdentificationResultStatus;
};

const Status = styled(Flex)<{ status: AppointmentsYakumaruPrescriptionIdentificationResultStatus }>(
  ({ theme, status }) =>
    css({
      position: 'absolute',
      left: '70px',
      top: '18px',
      backgroundColor:
        status === 'processing'
          ? theme.colors.colorPallete.white
          : status === 'failed'
            ? theme.colors.colorPallete.lightPink
            : theme.colors.colorPallete.lightGreen,
      width: '18px',
      height: '18px',
      textAlign: 'center',
      alignItems: 'center',
      justifyContent: 'center',
      borderRadius: theme.radii.circle,
    }),
);

export const WithPrescriptionIdentifyStatusIcon = (props: Props) => {
  const { children, status } = props;

  return (
    <>
      {children}
      <Status status={status}>
        {status === 'processing' && <Icon icon="sync" size="xs" color="grey" />}
        {status === 'failed' && <Icon icon="info" size="xs" color="pink" />}
        {status === 'finished' && <Icon icon="check" size="xs" color="green" />}
      </Status>
    </>
  );
};
